import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createTask } from "./api";
import type { TaskCreateRequest, TaskResponse } from "./api";

// На успешный POST — инвалидируем queries `tasks` и `queue`, чтобы
// UI сразу перерисовался, не дожидаясь следующего polling-tick'а
// (2 сек ощущается как лаг). Инвалидация по смысловому префиксу
// матчит запись любого org-скоупа (см. `src/query/scope.ts`).
export function useCreateTask(): ReturnType<
  typeof useMutation<TaskResponse, Error, TaskCreateRequest>
> {
  const queryClient = useQueryClient();
  return useMutation<TaskResponse, Error, TaskCreateRequest>({
    mutationFn: (body) => createTask(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["tasks"] });
      void queryClient.invalidateQueries({ queryKey: ["queue"] });
    },
  });
}
